import { render } from "./Contragent.vue?vue&type=template&id=ef46d55e"
import script from "./Contragent.vue?vue&type=script&lang=js"
export * from "./Contragent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__